import { render, staticRenderFns } from "./JiSu.vue?vue&type=template&id=17692952&scoped=true"
import script from "./JiSu.vue?vue&type=script&lang=js"
export * from "./JiSu.vue?vue&type=script&lang=js"
import style0 from "./JiSu.vue?vue&type=style&index=0&id=17692952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17692952",
  null
  
)

export default component.exports